module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/dara-cohen-91bc85d23a8054309bbe316711f1a95e.jpg";